import gql from 'graphql-tag';

export default gql`
  mutation ResetPassword($guid: UUID!, $verify: UUID, $password: String!) {
    resetPassword(guid: $guid, verify: $verify, password: $password)
  }
`;
